import {RegisterUserPresenter} from "@modules/onBoarding/application/port/output/RegisterUserPresenter";
import {RegisterUserResponse} from "@modules/onBoarding/application/usecase/RegisterUser/RegisterUserResponse";
import {ErrorMessagesViewModel} from "@modules/onBoarding/presentation/viewModel/ErrorMessagesViewModel";

export class RegisterUserWebPresenter implements RegisterUserPresenter {
    private readonly translations: ErrorMessagesViewModel;
    private viewModel: RegisterUserResponse;

    constructor(translations: ErrorMessagesViewModel) {
        this.translations = translations;
    }

    getViewModel(){
        return this.viewModel
    }

    presentUserRegistrationErrors(errors: RegisterUserResponse): void {
        const translatedErrors = {};

        Object.entries(errors).map((error) => {
            const inputKey = error[0]
            const errorKey = error[1]
            const inputErrorMessagesKey = inputKey + 'ErrorMessages';

            translatedErrors[inputKey] = this.translations[inputErrorMessagesKey][errorKey]
        });

        this.viewModel = translatedErrors;
    }

    presentNoUserRegistrationErrors(): void {
        this.viewModel = {};
    }
}
